import React from "react";
import Button from "@material-ui/core/Button";

export default function AlertDialog(props) {
  const { description, submitFunc } = props;

  const handleClickOpen = () => {
    const isConfirmed = window.confirm(description);

    if (!isConfirmed) {
      return;
    }

    submitFunc();
  };

  return (
    <React.Fragment>
      <div class={props.classes}>
        <Button
          variant="contained"
          color="primary"
          disabled={props.disabled || false}
          onClick={handleClickOpen}
          startIcon={React.createElement(props.icon)}
        >
          {props.title}
        </Button>
      </div>
    </React.Fragment>
  );
}
